export const LARGE_POINTS = 20;
export const MEDIUM_POINTS = 50;
export const SIZE: number = 100; // Starting size of asteroids in pixels.
export const SMALL_POINTS = 100;
